import {FC} from 'react';
import MuiBox from '../MuiBox';
import MuiTypography from '../MuiTypography';
import {FileIcon} from './icons';
import Link from 'next/link';

export interface UsefulResourceCardProps {
  title: string;
  subTitle: string;
  href: string;
  resourceType: 'download' | 'view';
}

const UsefulResourceCard: FC<UsefulResourceCardProps> = (props) => {
  return (
    <MuiBox
      component={Link}
      href={props.href}
      target='_blank'
      sx={{
        display: 'flex !important',
        gap: '16px',
        padding: '16px',
        background: 'rgba(127, 127, 127, 0.2)',
        borderRadius: '16px',
        cursor: 'pointer',
        textDecoration: 'none',
      }}>
      <MuiBox
        sx={{
          borderRadius: '8px',
          minWidth: '48px',
          minHeight: '48px',
          maxWidth: '48px',
          maxHeight: '48px',
          backgroundColor: 'rgba(255, 255, 255, 0.25)',
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
        }}>
        <FileIcon />
      </MuiBox>
      <MuiBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '3px',
          color: '#fff',
        }}>
        <MuiTypography
          title={props.title}
          sx={{
            fontWeight: 500,
            fontSize: '17px',
            lineHeight: '140%',
            letterSpacing: '-0.4px',
            // Clamp content to 1 lines
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical',
          }}>
          {props.title}
        </MuiTypography>
        <MuiTypography
          title={props.subTitle}
          sx={{
            fontWeight: 400,
            fontSize: '13px',
            lineHeight: '125%',
            letterSpacing: '0px',
            opacity: '0.6',
            // Clamp content to 1 lines
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical',
          }}>
          {props.subTitle}
        </MuiTypography>
      </MuiBox>
    </MuiBox>
  );
};

export default UsefulResourceCard;
